import { FC } from "react";

import { useScheduleCreatePageParams } from "~/src/routes/hooks";

import { ScheduleCreateFormContainer } from "../../features/settings/ScheduleForm";

import { ScheduleCreatePage } from "./presentations";

export const ScheduleCreatePageContainer: FC = () => {
  const { siteSlug } = useScheduleCreatePageParams();

  return (
    <ScheduleCreatePage siteSlug={siteSlug}>
      <ScheduleCreateFormContainer siteSlug={siteSlug} />
    </ScheduleCreatePage>
  );
};
